export const POSITION_BOTTOM = "bottom"
